import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import MphLogo from '../assets/MphLogo.png';
import RecruiterLogo from '../assets/RecruiterLogo.png'
import unifiedAuthManager from '../services/unifiedAuthManager';
import { useDispatch } from 'react-redux';
import { useFilter } from '../context/filterContext';

// Helper to get initials from name
function getInitials(name) {
  if (!name) return "";
  return name
    .split(' ')
    .filter(Boolean)
    .map(word => word[0]?.toUpperCase() || '')
    .join('');
}

const SignOutSvg = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    style={{ display: 'inline', verticalAlign: 'middle', marginRight: '8px' }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.593 10.943c.584.585.584 1.53 0 2.116L18.71 15.95c-.39.39-1.03.39-1.42 0a.996.996 0 0 1 0-1.41 9.552 9.552 0 0 1 1.689-1.345l.387-.242-.207-.206a10 10 0 0 1-2.24.254H8.998a1 1 0 1 1 0-2h7.921a10 10 0 0 1 2.24.254l.207-.206-.386-.241a9.562 9.562 0 0 1-1.69-1.348.996.996 0 0 1 0-1.41c.39-.39 1.03-.39 1.42 0l2.883 2.893zM14 16a1 1 0 0 0-1 1v1.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1.505a1 1 0 1 0 2 0V5.5A2.5 2.5 0 0 0 12.5 3h-7A2.5 2.5 0 0 0 3 5.5v13A2.5 2.5 0 0 0 5.5 21h7a2.5 2.5 0 0 0 2.5-2.5V17a1 1 0 0 0-1-1z"
        fill="#004645"
      ></path>
    </g>
  </svg>
);
const AboutUsSvg = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    style={{ display: 'inline', verticalAlign: 'middle', marginRight: '8px' }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
        fill="#004645"
      />
    </g>
  </svg>
);
const TrainingHubSvg = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    style={{ display: 'inline', verticalAlign: 'middle', marginRight: '8px' }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M12 2L1 7l11 5 9-4.09V17h2V7L12 2zM3 9.22v5.56l9 4.09 9-4.09V9.22L12 13 3 9.22z"
        fill="#004645"
      />
    </g>
  </svg>
);


const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSignout, setShowSignout] = useState(false);
  const profileRef = useRef(null);
  const signoutButtonRef = useRef(null);
  const user = unifiedAuthManager.getUnifiedUser();
   const { currentFilter, setCurrentFilter } = useFilter();
   const { currentSearch, setCurrentSearch } = useFilter();
  
  
  let navLinks;
const roles = Array.isArray(user?.user_roles) ? user.user_roles : [];

const isAdmin = roles.includes('ROLE_ADMIN');
const isHR = roles.includes('ROLE_HR');

if (isAdmin && isHR) {
  navLinks = [
    { name: 'Dashboard', path: '/adminDashboard' }, // choose rule
     { name: 'Recruiter Dashboard', path: '/recruiterDashboard' },
    { name: 'Jobs', path: '/jobs' },
    { name: 'Candidates', path: '/candidates' },
  ];
} 
else if (isAdmin) {
  navLinks = [
    { name: 'Dashboard', path: '/adminDashboard' },
    { name: 'Jobs', path: '/jobs' },
    { name: 'Candidates', path: '/candidates' },
  ];
} 
else if (isHR) {
  navLinks = [
    { name: 'Dashboard', path: '/recruiterDashboard' },
    { name: 'Jobs', path: '/jobs' },
    { name: 'Candidates', path: '/candidates' },
  ];
} 
else {
  navLinks = [];
}

  const isActive = (path) => location.pathname.startsWith(path);

function getHighestRoleDisplay(roles) {
  if (!roles || !Array.isArray(roles)) return null;
  if (roles.includes('ROLE_ADMIN')) return 'Admin';
  if (roles.includes('ROLE_HR')) return 'Recruiter';
  return null; // or fallback like 'User'
}
  // Hide signout dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      // If click is outside the profile area and not on the signout button, close dropdown
      if (
        profileRef.current &&
        !profileRef.current.contains(event.target)
      ) {
        setShowSignout(false);
      }
    }
    if (showSignout) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showSignout]);

  // Prevent dropdown from closing before signout click is handled
  // by using onMouseDown instead of onClick for the signout button
  const handleSignout = (e) => {
    e.preventDefault();
    e.stopPropagation();
      setCurrentFilter(null);
    setCurrentSearch('');
    
    // Clear Redux
 
    
    // Clear local storage if you're persisting context
    localStorage.removeItem('currentFilter');
    localStorage.removeItem('currentSearch');
    setShowSignout(false);
    unifiedAuthManager.clearAll?.();
    navigate('/login');
  };
const hasRoleBadge = user?.user_roles && Array.isArray(user.user_roles) && 
  (user.user_roles.includes('ROLE_ADMIN') || user.user_roles.includes('ROLE_HR'));
  return (
    <nav className="fixed top-0 left-0 w-full z-50 nav-bar-bg py-4 px-8 anim-slideDown">
      <div className="flex justify-between items-center w-full">

        {/* Logos */}
        <div className="flex items-center gap-4">
          <img src={MphLogo} alt="MPH Company Logo" className="h-12" />
          <img src={RecruiterLogo} alt="Recruiter Logo" className="w-16 mb-1" />
        </div>

        {/* Navigation Links */}
        <ul className="flex items-center gap-8 text-gray-600 font-semibold">
          {navLinks.map(({ name, path }) => (
            <li key={name}>
              <Link
                to={path}
                className={`
                  nav-link
                  ${isActive(path)
                    ? 'mph-primary active border-b-2 border-emerald-800'
                    : 'hover:mph-primary'
                  }
                  pb-1
                `}
                style={{
                  transition: 'border-bottom 0.2s'
                }}
              >
                {name}
              </Link>
            </li>
          ))}
        </ul>

        {/* User Profile */}
        <div className="flex items-center gap-4" ref={profileRef}>
          <div className={`text-right`}>
            <p className="font-bold mph-primary">
              {user?.name
                ? user.name
                  .split(' ')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  .join(' ')
                : ""}
            </p>
            <p className="text-xs text-gray-500">
              {user?.email ? user.email : ""}
            </p>
  
          </div>
          <div
            className="w-12 h-12 rounded-full flex items-center bg-gray-100 justify-center mph-primary font-bold text-xl select-none cursor-pointer relative"
            title={user?.name ? user.name : ""}
            onClick={() => setShowSignout((prev) => !prev)}
            tabIndex={0}
          >

            
    {(() => {
      const roleDisplay = getHighestRoleDisplay(user?.user_roles);
      return roleDisplay ? (
        <p className={`${roleDisplay === 'Admin' ? 'right-[3px]' : 'right-[-2px]'} absolute text-[8px] font-semibold leading-4 bottom-[-4px] bg-gradient text-white px-2 rounded-md`}>
          {roleDisplay}
        </p>
      ) : null;
    })()}

            {getInitials(user?.name)}
            {showSignout && (
              <div
                className="absolute right-0 top-14 bg-white border border-gray-200 rounded-lg shadow-lg py-2 px-4 min-w-[155px] z-50 anim-slideDown "
                style={{ minWidth: '155px' }}
              >
                <a
                title='About us'
                href="https://mphgsdmcc.sharepoint.com/:u:/s/MPHIntranet/Ee_VsRgSU8RBmagnaNxibzABitpVh1W-KQCTB-a2_wfBqw?e=VAAViq"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full text-left mph-primary text-xs font-semibold py-1 px-2 rounded transition-colors flex items-center hover:bg-gray-100"
                type="button"
              >
                <AboutUsSvg />
                About us
              </a>

                <a
                title='Training Hub'
                 href="https://mphgsdmcc.sharepoint.com/:f:/s/MPHIntranet/EuWCFPXqjG5Ln0CSMgizT_8BGEw7FfMuYLLMPr9XSduiyA?e=Ww5bb5"
                target="_blank"
                rel="noopener noreferrer"
                  className="w-full text-left mph-primary text-xs font-semibold py-1 px-2 rounded transition-colors flex items-center hover:bg-gray-100"
                  type="button"
                >
                  <TrainingHubSvg />
                  Training Hub
                </a>
                <button
                  title='Sign out'
                  ref={signoutButtonRef}
                  className="w-full text-left mph-primary text-xs font-semibold py-1 px-2 rounded transition-colors flex items-center hover:bg-gray-100"
                  type="button"
                  onMouseDown={handleSignout}
                >
                  <SignOutSvg />
                  Sign out
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;